import { IGetNovosNegociosArquivoByIdUseCase } from "../../../presentation/useCases/read/get_novos_negocios_arquivo_by_id_use_case";
import { NovosNegociosArquivo } from "../../models/novos_negocios_arquivo";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * GetNovosNegociosArquivoByIdUseCase
 */

export class GetNovosNegociosArquivoByIdUseCase implements IGetNovosNegociosArquivoByIdUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idNovosNegociosArquivo: number, imageName: string): Promise<void> {
    const blob = await this.repository.getNovosNegociosArquivoById(idNovosNegociosArquivo);
    if (!blob) throw new Error('Falha ao buscar dados da imagem!');

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', String(imageName));
    document.body.appendChild(link);
    link.click(); 
    
    link.remove();
    window.URL.revokeObjectURL(url);

  }
}
